export default function SelectStore() {
	const modal = document.querySelector(".theme-redirect-modal");
	let isModalOpen = false;
	const closeBtn = document.querySelector(
		".theme-redirect-modal-container__close"
	);
	const openBtns = document.querySelectorAll(".muse__store-link");
	const overLay = document.querySelector(".theme-redirect-modal__overlay");
	const body = document.querySelector("body");
	const html = document.querySelector("html");
	const tabLink = document.querySelectorAll(
		".theme-redirect-modal__nav-container-nav-item a"
	);
	const tabLinkMobile = document.querySelectorAll(
		".theme-redirect-modal__regions-container-mobile-nav-item a"
	);
	const tabs = document.querySelectorAll(
		".theme-redirect-modal__regions-container"
	);

	openBtns.forEach(el => el.addEventListener("click", function () {
		modal.classList.add("theme-redirect-modal--active");
		overLay.classList.add("theme-redirect-modal__overlay--active");
		body.classList.add("modal--active");
		html.classList.add("modal--active");
		isModalOpen = true;
	}));

	closeBtn.addEventListener("click", function () {
		removeActiveState();
	});

	tabLink.forEach((element) => {
		element.addEventListener("click", function (event) {
			let tab = document.getElementById(element.dataset.id);

			tabs.forEach((element) => {
				element.classList.remove("active_tab");
			});
			tabLink.forEach((element) => {
				element.classList.remove("active_link");
			});
			element.classList.add("active_link");
			tab.classList.add("active_tab");
		});
	});

	tabLinkMobile.forEach((element) => {
		element.addEventListener("click", function (event) {
			let tab = document.getElementById(element.dataset.id);

			tabs.forEach((element) => {
				element.classList.remove("active_tab");
			});
			tabLinkMobile.forEach((element) => {
				element.classList.remove("active_link");
			});
			element.classList.add("active_link");
			tab.classList.add("active_tab");
		});
	});

	//for accessibility purposes
	document.addEventListener("keydown", (e) => {
		if (isModalOpen && e.key === "Escape") {
			removeActiveState();
		}
	});

	function removeActiveState() {
		modal.classList.remove("theme-redirect-modal--active");
		overLay.classList.remove("theme-redirect-modal__overlay--active");
		body.classList.remove("modal--active");
		html.classList.remove("modal--active");
		isModalOpen = false;
	}

	const modalTabs = document.querySelectorAll("[data-tab='desktop']");
	const modalTabsMobile = document.querySelectorAll("[data-tab='mobile']");
	const modalTabsContent = document.querySelectorAll(
		".theme-redirect-modal__tab-content"
	);
	let currentTab = 0;
	const modalActiveTabCSSclass = "theme-redirect-modal__tab--active";
	const modalActiveCSSclass = "theme-redirect-modal__tab-content--active";

	modalTabs.forEach((el, index) => {
		el.addEventListener("click", () => {
			// tabs
			modalTabs[currentTab].classList.toggle(modalActiveTabCSSclass);
			modalTabs[index].classList.toggle(modalActiveTabCSSclass);
			// content inside tab
			modalTabsContent[currentTab].classList.toggle(modalActiveCSSclass);
			modalTabsContent[index].classList.toggle(modalActiveCSSclass);
			currentTab = index;
		});
	});

	modalTabsMobile.forEach((el, index) => {
		el.addEventListener("click", () => {
			// tabs
			modalTabs[currentTab].classList.toggle(modalActiveTabCSSclass);
			modalTabs[index].classList.toggle(modalActiveTabCSSclass);
			// content inside tab
			modalTabsContent[currentTab].classList.toggle(modalActiveCSSclass);
			modalTabsContent[index].classList.toggle(modalActiveCSSclass);
			currentTab = index;
		});
	});
}
